const mq = window.matchMedia('(max-width: 1000px)');

function handleLayout(e) {
  // ← ここがポイント
  if (!document.body.classList.contains('p-guest')) return;

  if (e.matches) {
    // SP時
    document.querySelectorAll('.block__content__list__item').forEach(item => {
      const desc = item.querySelector('.description');
      const text = item.querySelector('.text');
      if (desc && text && text.contains(desc)) {
        text.after(desc);
      }
    });
  } else {
    // PC時（元に戻す）
    document.querySelectorAll('.block__content__list__item').forEach(item => {
      const desc = item.querySelector('.description');
      const text = item.querySelector('.text');
      if (desc && text && !text.contains(desc)) {
        text.appendChild(desc);
      }
    });
  }
}

// 初回
handleLayout(mq);

// リサイズ監視
mq.addEventListener('change', handleLayout);
